export const flat =
  <T, Depth extends number = 1>(depth?: Depth) =>
  (array: T[]) =>
    array.flat(depth)
